// use only for the display of loot
define('lib/readable-monetize',[], function () {
  return function readableMonetize(val, options) {
    val = parseFloat(val);
    var maxDigits = 2;
    if (Math.floor(val) === val) {
      maxDigits = 0;
    }
    // default options for use with toLocalString
    options = Object.assign({
      maximumFractionDigits: maxDigits
    }, options);

    if (val || val === 0) {
      return val.toLocaleString('en-EN', options);
    }
    return null;
  };
});

